import { render, staticRenderFns } from "./ConfirmBox.vue?vue&type=template&id=356f3bba&"
import script from "./ConfirmBox.vue?vue&type=script&lang=js&"
export * from "./ConfirmBox.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/confirm-box.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports